// import {IActionRedux, IAppState} from 'src/types/appStateInterface';

import { IActionRedux, IAppState } from "../../types/appStateInterface";
import { pageReducer } from "./pageReducer";

export const mainReducer = (
  state: IAppState,
  action: IActionRedux
): IAppState => ({
  pageLoaderState: pageReducer(state.pageLoaderState, action),
});
